/** Must stay in sync with PaymentPayloadCryptography.KeyPurpose on the API. */
export const CHECKOUT_CONTEXT_KEY_PURPOSE = 'OnlineOrdering.PaymentCheckout.v1';

const deriveKeyMaterial = async (customerId, ooId, eventId) => {
  const seed = `${customerId}|${ooId}|${eventId}|${CHECKOUT_CONTEXT_KEY_PURPOSE}`;
  const encoder = new TextEncoder();
  const keyHash = await crypto.subtle.digest('SHA-256', encoder.encode(seed));
  const ivHash = await crypto.subtle.digest(
    'SHA-256',
    encoder.encode(`${seed}|iv`),
  );
  const key = await crypto.subtle.importKey(
    'raw',
    keyHash,
    { name: 'AES-CBC' },
    false,
    ['encrypt'],
  );
  const iv = ivHash.slice(0, 16);
  return { key, iv };
};

/**
 * Builds cartId: AES-CBC of checkout context (customerId, ooId, eventId).
 */
export const createCartId = async ({ customerId, ooId, eventId }) => {
  const { key, iv } = await deriveKeyMaterial(customerId, ooId, eventId);
  const payload = JSON.stringify({ customerId, ooId, eventId });
  const cipherBuffer = await crypto.subtle.encrypt(
    { name: 'AES-CBC', iv },
    key,
    new TextEncoder().encode(payload),
  );
  const bytes = new Uint8Array(cipherBuffer);
  let binary = '';
  bytes.forEach((byte) => {
    binary += String.fromCharCode(byte);
  });
  return btoa(binary);
};

export default createCartId;
